module.exports = __webpack_public_path__ + "static/assets/f27d07abf5b4698f21f888505174131e.svg";